import { ff } from '@atlassian/jira-feature-flagging';

export const isDisableEpicLinkAndParentLinkFieldsEnabled = () =>
	ff('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt', false);

export const isInviteFromAssignModalFeEnabled = () =>
	ff('invite.from.assign.modal.fe.event', false);
